import React from "react";
import { useHistory } from "react-router-dom";
import { IonIcon } from "@ionic/react";

import { gearthemesListPath, newRealizationPath } from "../../store/student";
import { IGearTheme } from "../../state";
import starIcon from "../../assets/icons/star.svg";

import styles from "./ThemeHeader.module.scss";

type ThemeHeaderProps = {
  geartheme: IGearTheme;
  isTimelinePage?: boolean;
  hideInputButton?: boolean;
  isTeacher?: boolean;
};

const ThemeHeader = ({
  geartheme,
  isTimelinePage = false,
  hideInputButton = false,
  isTeacher = false,
}: ThemeHeaderProps) => {
  const history = useHistory();

  return (
    <div className={styles.wrapper}>
      <div className={styles.banner}>
        <div className={styles.theme}>
          <IonIcon className={styles.icon} src={starIcon} />
          <span className={styles.themeText}>SUMMIT フェス 開催中</span>
          <IonIcon className={styles.icon} src={starIcon} />
        </div>
        <p className={styles.updateDate}>
          <span className={styles.note}>3回目の問い</span>
          <span className={styles.date}>11/12(水)更新</span>
        </p>
        <div className={styles.content}>
          <div className={styles.title}>
            <span className={styles.question}>{geartheme.title}</span>
          </div>
          <div className={styles.buttons}>
            {!isTimelinePage && (
              <button
                className={styles.viewButton}
                onClick={() => {
                  history.push(`${gearthemesListPath}/${geartheme.id}`);
                }}
              >
                みんなの回答を見る
              </button>
            )}
            {!hideInputButton && !isTeacher && (
              <button
                className={styles.stockButton}
                onClick={() => {
                  history.push({
                    pathname: newRealizationPath,
                    search: "?hasTheme=true",
                  });
                }}
              >
                ストックする
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThemeHeader;
